import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { getStepBarState } from '../../../../configurator-app/conf-store/reducer/stepbar.reducer';
import * as actions from '../../../conf-store/action/index';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { Subscription, lastValueFrom, take } from 'rxjs';
import { CookieService } from 'ngx-cookie-service';
import { ConfLobControlService } from '../../Services/conf-lob-service/conf-lob-control.service';
declare var $: any;
import { environment } from '../../../../../environments/environment';
import { getAllState } from '../../../../configurator-app/conf-store/reducer';


@Component({
  selector: 'app-conf-progress-step-bar',
  templateUrl: './conf-progress-step-bar.component.html',
  styleUrls: ['./conf-progress-step-bar.component.scss']
})
export class ConfProgressStepBarComponent implements OnInit {
  confAWSUrlStr: any = environment.confAWSurl;
  stepBarState!: any;
  modalStatus!: any;
  newSelectedVal!: any
  newSelectedOtherVal!: any
  progressStepBarImage: any;
  currentStepTitle: any = "";
  postSubscribe: any = new Subscription;
  
  @ViewChild('widgetsContent', { read: ElementRef })
  public widgetsContent!: ElementRef<any>;

  len: any;

  imgurl = true

  change() {
    this.imgurl = !this.imgurl;
  }

  constructor(
    public dialog: MatDialog,
    private _dataLobService: ConfLobControlService,
    private router: Router,
    private cookie_service: CookieService,
    private store: Store) {
    this.store.pipe(select(getStepBarState))
      .subscribe(data => {
        this.stepBarState = data;
        this.len = data.stepArr.length - 1
        let currentStep = data.currentStep;
        this.currentStepTitle = data.stepArr[currentStep]?.title
        let deadend = this.len - 3
        if (data.currentStep >= deadend) {
          this.widgetsContent?.nativeElement?.scrollTo({ left: (this.widgetsContent.nativeElement.scrollLeft + 300), behavior: 'smooth' });
        }
        else if (data.currentStep <= 3) {
          this.widgetsContent?.nativeElement?.scrollTo({ left: (this.widgetsContent.nativeElement.scrollLeft - 300), behavior: 'smooth' });
        }

        this.newSelectedVal = data.newSelectedValue
        this.newSelectedOtherVal = data.newSelectedOther
        this.modalStatus = data.showEditModal
      });
  }

  ngOnInit(): void {
    // let stepobj: any = window.localStorage.getItem('selectedLobObj');
    // stepobj = JSON.parse(stepobj);

    let lobRoute = this.router.url.split("/");

    let selectedLob = lobRoute[2]
    //this.stepBarState.selectedConfLob // stepobj['lob_selected']
    if (selectedLob === 'bus') {
      this.progressStepBarImage = this.confAWSUrlStr + "/common/conf-progress-bus-5.png"
    }
    else if (selectedLob === 'winger') {
      this.progressStepBarImage = this.confAWSUrlStr + "/common/conf-progress_winger.png"
    }
    else if (selectedLob === 'magic') {
      this.progressStepBarImage = this.confAWSUrlStr + "/common/conf-progress_magic.png"
    }
    else if (selectedLob === 'hcv') {
      this.progressStepBarImage = this.confAWSUrlStr + "/common/conf-hcv-stepper-image.png"
    }
    else if (selectedLob === 'ilmcv') {
      this.progressStepBarImage = this.confAWSUrlStr + "/common/conf-ilmcv-stepper-image.png"
    }
    else if (selectedLob === 'scv') {
      this.progressStepBarImage = this.confAWSUrlStr + "/common/conf-progress-scv.svg"
    }
    else {
      this.progressStepBarImage = this.confAWSUrlStr + "/common/conf-progress-truck.png"
    }

  }

  goToStep(stepValue: number): void {
    if (this.stepBarState.stepArr[stepValue].value !== '') {
      this.store.dispatch(actions.initOnRoute(stepValue))
      this.router.navigate(['/configurator/' + this.stepBarState.stepArr[stepValue].path])
    }
    $('#flush-collapseOne').collapse('hide');
  }

  no_change() {
    this.store.dispatch(actions.dismissModal())
  }

  async save_change() {
    if (this.newSelectedVal !== null) {
      const nextPath = this.stepBarState.stepArr[this.stepBarState.currentStep + 1].path

      // #######  HCV previous state (additional feature) value change VAS popup configuration ####### - kartik

      if (this.stepBarState.selectedConfLob.toLowerCase() === 'hcv' && this.stepBarState.currentStep == 7) {
        this.store.dispatch(actions.saveSelectionValueOnModal(this.stepBarState.newSelectedValue, this.stepBarState.newSelectedOther))
        this.router.navigate(['/configurator/hcv/hcv-base-vehicle-2']);
      }

      else if (this.stepBarState.selectedConfLob.toLowerCase() === 'ilmcv' && this.stepBarState.stepArr[this.stepBarState.currentStep].title === "Base Vehicle") {
        this.store.dispatch(actions.saveSelectionValueOnModal(this.stepBarState.newSelectedValue, this.stepBarState.newSelectedOther))
        this.router.navigate(['/configurator/ilmcv/ilmcv-base-vehicle-2']);
      }
      // #######  All LOB previous state value change model "yes sure" click #######

      else {
        this.store.dispatch(actions.saveSelectionValueOnModal(this.newSelectedVal, this.newSelectedOtherVal))
        this.router.navigate(['/configurator/' + nextPath]);
      }

      let saveSelection = await this.saveConfSelection();

    }
  }

  updateRoute(status: any) {
    this._dataLobService.updateConfChangeData(status)
  }

  async saveConfSelection() {
    const promise = new Promise(async (res: any, rej: any) => {
      let state = await lastValueFrom(this.store.pipe(select(getAllState), take(1)));
      let postPayload: any = {}

      let conf_id = this.cookie_service.get("configuration_id");

      if (conf_id == "" || conf_id == undefined) {
        postPayload['configuration_id'] = ""
      } else {
        postPayload['configuration_id'] = conf_id
      }
      let stateObj: any = {};
      stateObj['stepState'] = state.stepBarState;
      stateObj['lobDataState'] = state.lobDataState;
 

      postPayload['last_visited_step_json'] = JSON.stringify(stateObj)

      if (state.stepBarState.selectedConfLob === 'magic')
        postPayload['lob'] = 'tata_magic'
      else
        postPayload['lob'] = state.stepBarState.selectedConfLob

      let currentStep = state.stepBarState['currentStep'];
      let currentStepTitle = state.stepBarState.stepArr[currentStep].title

      // postPayload['vc_no'] = '123' //Need to remove once mandator vc column removed from table
      if (currentStepTitle === 'Summary') {
        postPayload['vc_no'] = state.lobDataState.selectedVCNumber[state.stepBarState.selectedConfLob];
      }

      postPayload['source'] = "configurator"

      //Will be changed with osp code token fetch
      // let authToken: any = bearerToken.token
      let authToken: any = this.cookie_service.get("access_token") // OSP team

      // /*
      this.postSubscribe = this._dataLobService.getConfDataAuthenticate("add_user_activity", postPayload, authToken).subscribe((result: any) => {
        if (result['RESPONSE']['STATUS_CODE'] == 200) {
          let configurator_id = result['RESPONSE']['Configuration_Id']
          if (conf_id == "" || conf_id == undefined) {
            this.cookie_service.set("configuration_id", configurator_id)
          }
          res();
        }
      },
        error => {
        }

      )

    })

    return promise;
  }
}
